import ExpandButton from 'components/molecules/expand-button';
import { useState, type FC, type PropsWithChildren } from 'react';
import CollapseAnimation from 'components/atoms/base-animations/collapse';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

interface CcmConsoleTableBlockProps extends PropsWithChildren {
  title: string;
  total: number;
}

const CcmConsoleTableBlock: FC<CcmConsoleTableBlockProps> = ({
  title,
  total,
  children,
}) => {
  const [expanded, setExpanded] = useState(true);
  const { t } = useTranslation();
  const dataCy = title.toLowerCase().split(' ').join('-');

  const toggleExpand = () => setExpanded(!expanded);

  return (
    <div className={s.wrapper}>
      <div className={s.header}>
        <h3 className={s.title} onClick={toggleExpand}>
          {title}
        </h3>
        <div className={s['header-right']}>
          <div className={s.total}>
            <p>{t('labels.total')}: </p>
            <p>{total}</p>
          </div>
          <ExpandButton
            expanded={expanded}
            dataCy={dataCy}
            onClick={toggleExpand}
          />
        </div>
      </div>
      <CollapseAnimation opened={expanded}>
        <div className={s.body}>{children}</div>
      </CollapseAnimation>
    </div>
  );
};
export default CcmConsoleTableBlock;
